<template>
    <div class="modal fade" tabindex="-1" :id="id">
        <div class="modal-dialog modal-lg">
          <form id="kt_modal_form_allowance" @submit.prevent="addAllowance" class="form mt-5" >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ $t('allowance.add') }}</h5>
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor"/>
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor"/>
                    </svg>
                  </span>
                </div>
              </div>
              <AllowanceForm  :id="id" :form-data="formData"/>
              <div class="modal-footer">
                <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
                <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
              </div>
            </div>
          </form>
        </div>
      </div>
</template>

<script setup>

import { defineProps,ref } from 'vue';
import { useStore } from "vuex";
import Button from "@/components/Button.vue"
import AllowanceForm from './AllowanceForm.vue';
import { computed } from 'vue';

const props = defineProps({
    formEdit:{
        type:Object,
        default:{}
    },
    id:{type: String, default:"create_allowance_modal"}
})

const store = useStore()

const formData = ref({
  title: '',
  society_id: "",
  allowance_data : [
      {
        type: 'amount',
        value: 0,
        range_min: 0,
        range_max: ''
      }
  ],

})
const currentSociety = computed(() => store.getters['offices/getSelectedCompany'])

const isLoading = ref(false)

const emit = defineEmits(['reloadDatatable'])


function closeModal(){
  $('#'+props.id).modal('toggle')
}

async function addAllowance() {
    isLoading.value = true
    try{
      await store.dispatch('allowances/createAllowance', {...formData.value, society_id: currentSociety.value?.id})
      window.toastr.success(i18n.global.t("notification.allowance_created"))
      emit('reloadDatatable')
      formData.value={
        title: '',
        society_id: "c46ed830-eeed-4668-88a5-eea7d809f4c2",
        allowance_data : [
            {
              type: 'amount',
              value: 0,
              range_min: '',
              range_max: ''
            }
        ],
      }
      isLoading.value = false
      $('#'+props.id).modal('toggle')
    }catch(err){
      isLoading.value = false
    }
}

</script>
